import React from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Text from './styled';
import { useDispatch } from 'react-redux';
import { setCredentialSelected, showCredentialDetail } from 'store/Credentials/actions';

const UsernameCell = ({ rowInfo, showSkeleton, field, isVulnDetail = false }) => {
  const dispatch = useDispatch();
  const label = get(rowInfo, `original.value.${field}`, '');
  const workspace = get(rowInfo, 'original.value.workspace_name', '');
  const id = get(rowInfo, 'original.value.id', '');

  const onClick = () => {
    if (!isVulnDetail) {
      dispatch(showCredentialDetail(true, workspace, id));
      dispatch(setCredentialSelected(get(rowInfo, 'original', {})));
    }
  };

  if (showSkeleton) return <Skeleton />;
  return (
    <Text onClick={ onClick }>
      { label }
    </Text>
  );
};

UsernameCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool
};

UsernameCell.defaultProps = {
  field: '',
  showSkeleton: false
};

export default UsernameCell;
